import React from 'react';
import useChangeModalVisible from '../../../../../hooks/useChangeModalVisible';
import { AllTenantDocumentsModal } from '../../ui/modals/AllTenantDocumentsModal/AllTenantDocumentsModal';
import styles from './ShowAllTenantDocuments.module.scss';
import cn from 'classnames';
import { Button } from 'antd';

export const ShowAllTenantDocuments = ({
  className,
  clientId,
  text = 'Смотреть все',
}) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  const handleOpenModal = () => {
    showModal();
  };

  return (
    <>
      <AllTenantDocumentsModal
        clientId={clientId}
        visible={visible}
        onCancel={hideModal}
      />
      <Button
        onClick={handleOpenModal}
        className={cn(styles.button, className)}
      >
        {text}
      </Button>
    </>
  );
};
